// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3mDrH","errorLogs":"styles_errorLogs__3NJpJ"};